import React from 'react';
import Icon from '../../../components/AppIcon';

const OpportunityTable = ({ opportunities, formatCurrency, getProbabilityColor }) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-50 dark:bg-slate-700">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Company
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Deal Value
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Probability
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Stage
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Expected Close
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Competition
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white dark:bg-slate-800 divide-y divide-gray-200 dark:divide-slate-700">
          {opportunities?.map((opp) => (
            <tr key={opp?.id} className="hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors">
              <td className="px-6 py-4">
                <div>
                  <div className="text-sm font-medium text-gray-900 dark:text-white">
                    {opp?.company}
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    Assigned to {opp?.assignedTo}
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="text-sm font-semibold text-gray-900 dark:text-white">
                  {formatCurrency(opp?.dealValue)}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${getProbabilityColor(opp?.probability)}`}>
                  {opp?.probability}%
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div>
                  <div className="text-sm text-gray-900 dark:text-white">{opp?.stage}</div>
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    {opp?.daysInStage} days in stage
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div>
                  <div className="text-sm text-gray-900 dark:text-white">
                    {new Date(opp?.expectedClose)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    {opp?.nextMilestone}
                  </div>
                </div>
              </td>
              <td className="px-6 py-4">
                <div>
                  <div className="text-sm text-gray-900 dark:text-white">{opp?.competitor}</div>
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    Position: {opp?.competitivePosition}
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <button className="text-emerald-600 hover:text-emerald-900 dark:text-emerald-400 dark:hover:text-emerald-300 mr-3">
                  <Icon name="Eye" size={16} />
                </button>
                <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300">
                  <Icon name="Edit" size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OpportunityTable;